var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { h, c } from '@debbie/cortex/dist';
import * as creditors from '@debbie/cortex/dist/api/creditors';
import { Size } from '../../design-system';
import Checkbox from '../Checkbox';
import { ChevronDown, ChevronRight } from '../Icons';
import VoucherApplication from './VoucherApplication';
import q from '@debbie/cortex/dist/query';
import { allCreditorsKey, useAllCreditors } from '@debbie/cortex/dist/creditors';
const setCustomVouchers = (creditorId, to) => __awaiter(void 0, void 0, void 0, function* () {
    yield creditors.update(creditorId, { customVoucherApplications: to });
    q.invalidate([allCreditorsKey()]);
});
const CreditorVoucherApplications = (props) => {
    const lang = useSelector((s) => s.lang);
    const allCreditorsLoadable = useAllCreditors();
    const allCreditors = h.hasData(allCreditorsLoadable)
        ? allCreditorsLoadable.data
        : null;
    const voucherApplications = useSelector((s) => s.voucherApplications[props.tenantId]);
    const [open, setOpen] = useState(false);
    const relevantCreditorId = props.creditorId || null;
    const creditorMap = allCreditors != null
        ? allCreditors.reduce((acc, creditor) => {
            acc[creditor.creditorId] = creditor;
            return acc;
        }, {})
        : {};
    useEffect(() => {
        if (h.isNotLoaded(voucherApplications)) {
            c.voucherApplications.getVoucherApplications(props.tenantId);
        }
    }, [props.tenantId]);
    const creditor = creditorMap[props.creditorId];
    const active = creditor.customVoucherApplications;
    const relevantApplications = h.hasData(voucherApplications)
        ? voucherApplications.data.filter((va) => va.creditorId == relevantCreditorId)
        : [];
    return (React.createElement(Wrapper, null,
        creditorMap[props.creditorId] != null ? (React.createElement(Creditor, null,
            React.createElement(CreditorLeft, null,
                React.createElement(Chevron, null, open ? (React.createElement(ChevronDown, { onClick: () => {
                        setOpen(false);
                    } })) : (React.createElement(ChevronRight, { onClick: () => {
                        setOpen(true);
                    } }))),
                // @ts-ignore
                React.createElement(CreditorLink, { to: `/creditors/${props.creditorId}` },
                    creditorMap[props.creditorId].name,
                    " (",
                    relevantApplications.length,
                    ")")),
            React.createElement(Checkbox, { size: Size.Small, style: {
                    marginBottom: '0px',
                    marginRight: '10px',
                }, checked: active, onChange: (e) => __awaiter(void 0, void 0, void 0, function* () {
                    yield setCustomVouchers(props.creditorId, e.target.checked);
                }) }))) : null,
        open && h.hasData(voucherApplications)
            ? relevantApplications.map((va) => {
                return (React.createElement(ApplicationsListItem, { key: va.id },
                    React.createElement(VoucherApplication, { voucherApplication: va, inactive: !active })));
            })
            : null));
};
const Wrapper = styled.div `
  width: 100%;
`;
const Creditor = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid lightgray;
  width: 100%;
`;
const CreditorLink = styled.p ``;
const CreditorLeft = styled.div `
  display: flex;
  align-items: center;
`;
const ApplicationsListItem = styled.div `
  padding: 10px;
  border-bottom: 1px solid lightgray;
`;
const Chevron = styled.div `
  cursor: pointer;
  padding: 10px;
`;
export default CreditorVoucherApplications;
//# sourceMappingURL=CreditorVoucherApplications.js.map